import { action, observable } from "mobx";
import { ChannelFlowVM } from "./ChannelFlowForm/ChannelFlowFormVM";
import { SoilStrengthFormVM } from "./SoilStrengthForm/SoilStrengthFormVM";
import { WaterwaySizingController } from "cd-eft/services/eftSetApi";
import { WaterwaySizingParamsDTO, WaterwaySizingResponseDTO } from "cd-eft/_codegen_/openapi-generator/eft-set";
import { VegetalCoverVM } from "./VegetalCoversComp/VegetalCoversVM";
import MessageCenter from "cd-eft/components/common/MessageCenter/MessageCenterVM";
import { SurfaceDesignerVm } from 'cd-eft/components/Design/SurfaceDesigner/SurfaceDesignerVm';
import { capAndUnderscore } from "cd-eft/utils/stringUtilities";
import stores from '../../../models/Stores'
import { AdminGlobalPreferenceController } from 'cd-eft/services/eftPrjAdminApi';

const waterwayDesignStore = stores.AppStore.waterwayDesignStore;


export interface IWscVmProps {
  mode: 'design' | 'standalone' | 'adminGlobalPreferences';
  size?: 'small' | 'medium' | 'default';
  surfaceDesignerVm?: SurfaceDesignerVm;
  vegCoverOptions?: String[];
  prefJson?:any;
  prefId?:number;
  terraceUiStateCallback?: any;
}
export class WaterwaySizingCalculatorVM {
  channelFlowVM: ChannelFlowVM | undefined = undefined;
  soilStrengthVM: SoilStrengthFormVM | undefined = undefined;
  vegetalCoverVM: VegetalCoverVM | undefined = undefined;
  surfaceDesignVM: SurfaceDesignerVm | undefined = undefined;
  mode: 'design' | 'standalone' | 'adminGlobalPreferences' = 'standalone';
  size: 'small' | 'medium' | 'default' = 'default';
  perfJson:any = {};
  prefId:number | undefined = undefined;

  private widthEdited: boolean = false;
  private depthEdited: boolean = false;

  constructor(props: IWscVmProps) {
    this.channelFlowVM = new ChannelFlowVM(props);
    this.soilStrengthVM = new SoilStrengthFormVM(props);
    this.vegetalCoverVM = new VegetalCoverVM(props);
    this.surfaceDesignVM = props.surfaceDesignerVm;
    this.mode = props.mode;
    this.prefId = props.prefId;

    if (this.mode === 'design') {
      waterwayDesignStore.updateSelectedReachNames();
      this.channelFlowVM.channelBedSlope = +((waterwayDesignStore.svcProps.slope!) * 100).toFixed(2);// From WDT as 0.0#### -> #.## in WSC
      this.channelFlowVM.designDischarge = waterwayDesignStore.svcProps.totalQ!;
      this.channelFlowVM.trapForm.freeboard = waterwayDesignStore.svcProps.freeBoard!;
      this.channelFlowVM.parabolicForm.freeboard = waterwayDesignStore.svcProps.freeBoard!;
      if (waterwayDesignStore.svcProps.soilStrengthName) {
        this.soilStrengthVM.erodibilityForm.erodibility = waterwayDesignStore.svcProps.soilStrengthName;
      }
      else {
        this.soilStrengthVM.erodibilityForm.allowableStress = waterwayDesignStore.svcProps.soilStrengthValue!;
        this.soilStrengthVM.soilStressForm.allowableStress = +waterwayDesignStore.svcProps.soilStrengthValue!;
      }
      const vegCoverOption = waterwayDesignStore.svcProps.vegCoverName+` (${waterwayDesignStore.svcProps.vegCover})`;
      if(props.vegCoverOptions?.includes(vegCoverOption)){
        this.vegetalCoverVM.defineVegetalCoverForm.vegetalCoverDropdown = waterwayDesignStore.svcProps.vegCoverName + " (" + waterwayDesignStore.svcProps.vegCover+")";
        this.vegetalCoverVM.disableVegetalCoverManualInputs = true;
        this.vegetalCoverVM.defineVegetalCoverForm.manualboxOne = "";
        this.vegetalCoverVM.defineVegetalCoverForm.manualboxTwo = "";
      }
      else{
        this.vegetalCoverVM.defineVegetalCoverForm.vegetalCoverDropdown = 'Manual Entry'
        this.vegetalCoverVM.disableVegetalCoverManualInputs = false;
        this.vegetalCoverVM.defineVegetalCoverForm.manualboxOne = waterwayDesignStore.svcProps.vegCoverName!;
        this.vegetalCoverVM.defineVegetalCoverForm.manualboxTwo = +waterwayDesignStore.svcProps.vegCover!
      }
      
      this.vegetalCoverVM.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity = waterwayDesignStore.svcProps.capacity!;
      this.vegetalCoverVM.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability = waterwayDesignStore.svcProps.stability!;
      this.channelFlowVM.channelControl = waterwayDesignStore.channelControl === "TRAPEZOIDAL" ? 0 : 1;
      this.channelFlowVM.trapForm.leftSlope = +(waterwayDesignStore.svcProps.leftSS!)
      this.channelFlowVM.trapForm.rightSlope = +(waterwayDesignStore.svcProps.rightSS!)
      this.channelFlowVM.trapForm.minBedWidth = +(waterwayDesignStore.svcProps.bottomWidth!)
      this.channelFlowVM.parabolicForm.limitingSlope = +(waterwayDesignStore.svcProps.leftSS!)
      this.channelFlowVM.parabolicForm.offset = [waterwayDesignStore.svcProps.offset1!, waterwayDesignStore.svcProps.offset2!, waterwayDesignStore.svcProps.offset3!];
      this.size = props.size!;
    }

    this.handleCloseDesignCalculator = this.handleCloseDesignCalculator.bind(this);
  }
  @observable saveButtonPopup: boolean = false;

  @observable DefineSoilStrengthCollapse: boolean | undefined = false;
  @observable DefineVegetalCoverCollapse: boolean | undefined = false;
  @observable DefineChannelandFlowCollapse: boolean | undefined = false;
  @observable erodibilityMenu = this.soilStrengthVM?.erodibilityMenu;
  @observable vegetalCoverMenu: any = [1, 2, 3, 4];
  @observable waterWayWizardStatus: number = 1;  // 1: default, 2: success, 3:error
  @observable onClickInformation: boolean = false;
  @observable headerTitle: string = ''
  @observable resultCardButtonChange: boolean = false //to position calculate button as per the size of the result card

  @observable lastCalcPayload: WaterwaySizingParamsDTO | undefined = undefined;
  @observable lastOthersObj: any = undefined;
  @observable calculationResult: WaterwaySizingResponseDTO | undefined = undefined;
  @observable calculateLock: boolean = false;
  @observable reportLock: boolean = true;
  @observable isLoading: boolean = false;
  @observable statusErrorCode: string = "";
  @observable statusErrorMessage: string = "";

  @observable defineSoilStrengthForm: any = {
    allowableSoilStress: '',
    erodibility: '',
  };

  @action.bound getReqValuesForGlobalPreferences(){
    this.handleReset();
    if(this.soilStrengthVM){
      this.soilStrengthVM.erodibilityForm.erodibility = this.perfJson.soilParameters.stressFactorStr ? capAndUnderscore(this.perfJson.soilParameters.stressFactorStr) : '';
    }
    if(this.vegetalCoverVM){
      this.vegetalCoverVM.defineVegetalCoverForm.vegetalCoverDropdown =  this.perfJson.vcDescription + " ("+this.perfJson.vcffactor+")";
      this.vegetalCoverVM.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity = this.perfJson.vegetalCapacityParams.retClassStr;
      this.vegetalCoverVM.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability = this.perfJson.vegetalStabilityParams.retClassStr;

     //radio selection left as default
     this.vegetalCoverVM.defineVegetalCoverForm.rciForm.rciCapacity =  this.perfJson.vegetalCapacityParams.rci;
     this.vegetalCoverVM.defineVegetalCoverForm.rciForm.rciStability =  this.perfJson.vegetalStabilityParams.rci;

     this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityDensity =  this.perfJson.vegetalCapacityParams.stemDensity;
     this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityLength =  this.perfJson.vegetalCapacityParams.stemLength;
     this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityDensity =  this.perfJson.vegetalStabilityParams.stemDensity;
     this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityLength =  this.perfJson.vegetalStabilityParams.stemLength;

     //these values not received
     let vegOption = this.perfJson.vegetalCapacityOption;
     if (this.perfJson.vegetalCapacityOption === 'Retardance Class' && this.perfJson.vegetalStabilityOption === 'Retardance Class' ) {
      this.vegetalCoverVM.RetardanceClassControl = 0 ;
    } else if (this.perfJson.vegetalCapacityOption === 'Retardance Curve Index' && this.perfJson.vegetalStabilityOption === 'Retardance Curve Index') {
      this.vegetalCoverVM.RetardanceClassControl = 1 ;
    } else if (this.perfJson.vegetalCapacityOption === 'Stem length/density' && this.perfJson.vegetalStabilityOption === 'Stem length/density') {
      this.vegetalCoverVM.RetardanceClassControl = 2 ;
    } else if (this.perfJson.vegetalCapacityOption === "Manning's n" && this.perfJson.vegetalStabilityOption === "Manning's n") {
      this.vegetalCoverVM.RetardanceClassControl = 3 ;
    } else{
      //default
      this.vegetalCoverVM.RetardanceClassControl = 0 ;
    }
    //  this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemStabilityRci =  Not received
    //  this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemCapacityRci =  Not received
    this.vegetalCoverVM.defineVegetalCoverForm.manningForm.manningCapacity = this.perfJson.vegetalCapacityParams.manningsN
    this.vegetalCoverVM.defineVegetalCoverForm.manningForm.manningStability = this.perfJson.vegetalStabilityParams.manningsN

    }
    if(this.channelFlowVM){
      this.channelFlowVM.channelControl = this.perfJson.channelParams.channelShapeStr === "TRAPEZOIDAL" ? 0 : 1;
      this.channelFlowVM.parabolicForm.offset = [this.perfJson.channelParams.offset1!, this.perfJson.channelParams.offset2!, this.perfJson.channelParams.offset3!];
      this.channelFlowVM.trapForm.leftSlope = +(this.perfJson.channelParams.leftSlopeRatio!)
      this.channelFlowVM.trapForm.rightSlope = +(this.perfJson.channelParams.leftSlopeRatio!)
      this.channelFlowVM.trapForm.minBedWidth = +(this.perfJson.channelParams.minBedWidth!)
      this.channelFlowVM.parabolicForm.limitingSlope = +(this.perfJson.channelParams.sideWidthLimit!)

    }

  }

  @action.bound async initializeParameters() {
    await this.soilStrengthVM?.getParameters();
    await this.vegetalCoverVM?.getVegetalParameters();
  }

  @action.bound onClickReportToggle() {
    // return true if you want proceed to the next page
    this.saveButtonPopup = true;
    return;
  }

  @action onClickInformationToggle = (title) => {
    this.headerTitle = title
    this.onClickInformation = !this.onClickInformation
  }

  handleCloseDesignCalculator() {
      waterwayDesignStore.closeWscComponent();
  }

  async validateCalculator() {
    const soil = this.soilStrengthVM?.soilStrengthSummaryValidation;
    const veg = await this.vegetalCoverVM?.fullSelectiveValidation();
    const channel = this.channelFlowVM?.validateAllSelected();
    if (!soil || veg || channel) {
      return true // at least one Invalid
    }
    else return false // All Valid
  }

  get getAllFormInputs() {
    const vegetalDto = this.vegetalCoverVM?.exportVegetalCoverDTO;
    const soilDto = this.soilStrengthVM?.exportSoilStrengthDto;
    const channelDto = this.channelFlowVM?.exportChannelFlowDto;
    if (channelDto?.dataVertex) {
      this.widthEdited = channelDto.dataVertex.widthEdited ? channelDto.dataVertex.widthEdited : false;
      this.depthEdited = channelDto.dataVertex.depthEdited ? channelDto.dataVertex.depthEdited : false;;
    };
    const requestDTO: WaterwaySizingParamsDTO = {
      soilParameters: soilDto,
      ...channelDto,
      ...vegetalDto,
      alignmentStation: undefined,
    }
    return requestDTO;
  }
  get getOthers() {
    let coverFactor = '';
    if (this.vegetalCoverVM?.defineVegetalCoverForm.vegetalCoverDropdown === 'Manual Entry') {
      coverFactor = `${this.vegetalCoverVM?.defineVegetalCoverForm.manualboxOne} (${this.vegetalCoverVM?.defineVegetalCoverForm.manualboxTwo})`;
    }
    else if (this.vegetalCoverVM?.defineVegetalCoverForm.vegetalCoverDropdown !== '') {
      const cover = this.vegetalCoverVM?.vegetalCoverOptions.find((item) => item.value === this.vegetalCoverVM?.defineVegetalCoverForm.vegetalCoverDropdown);
      if (cover) {
        coverFactor = cover.name;
      }
    }
    return {
      coverFactor: coverFactor,
    }
  }

  @action.bound async saveGlobalPref(){
    this.isLoading = true;
    const prefId = this.prefId;
    await this.validateCalculator();
    const requestDTO: WaterwaySizingParamsDTO = { ...this.getAllFormInputs };
    try{
      await AdminGlobalPreferenceController.updatePreferenceValueJsonByIdUsingPOST(prefId as number, requestDTO as string);
    }catch(error){
      console.error(error)
    }
    this.isLoading = false;
  }

  @action.bound async finalCalculation() {
    this.calculateLock = true;
    if (await this.validateCalculator()) {
      this.calculateLock = false;
      return;
    }
    const requestDTO: WaterwaySizingParamsDTO = { ...this.getAllFormInputs };
    requestDTO.channelSlope = requestDTO.channelSlope! / 100.0;
    try {
      const response = await WaterwaySizingController.calculateWaterwaySizingUsingPOST(requestDTO);
      if (response) {
        if (response.data) {
          if ((response.data as any).errorMessage) {
            throw new Error((response.data as any).errorMessage);
          }
          this.calculationResult = response.data;
          if (this.mode === 'design') {
            waterwayDesignStore.waterwaySizingCalculatorResults = this.calculationResult
          }
          if (this.calculationResult.warningMsgs && this.calculationResult.warningMsgs.length > 0) {
            // If there are warningMsgs in response, put into single warning notification
            let warningMessage = '';
            this.calculationResult.warningMsgs.forEach((msg) => {
              warningMessage += msg + '.\n';// This doesn't have any effect here but can be something to modify in MC refactor.
            })
            MessageCenter.addWarning(warningMessage);
          }
          // Copy inputs for report to variables
          this.lastCalcPayload = { ...requestDTO };
          this.lastCalcPayload.channelSlope! *= 100;
          // Offsets are in decimal form (/ 100). Do * 100 if adding to report
          this.lastOthersObj = { ...this.getOthers };
          this.waterWayWizardStatus = 2;
          waterwayDesignStore.updateSelectedReachNames();
        }
        else {
          // TODO: Error in 200 response
        }
      }
    }
    catch (error) {
      // await MessageCenter.addNotificationFromCode('WDT_61');// Comment out until we have a proper error
      await this.validateCalculator();
      this.waterWayWizardStatus = 3;
      console.error(error);
      MessageCenter.addError((error as Error).message)
    }
    finally {
      this.calculateLock = false;
    }
  }

  handleCloseDesignCaclulator() {
    waterwayDesignStore.closeWscComponent();
  }

  @action.bound cancelGlobalPref(){

  }

  @action.bound async handleApplyPropertiesToSelectedReaches() {

    if (waterwayDesignStore.selectedWaterwayStations.length === 0) {
      MessageCenter.addNotificationFromCode('WDT_134');
      return;
    }
    this.isLoading = true;
    try {
      if (waterwayDesignStore.selectedWaterwayStations.length > 0) {
        let resetDepth = waterwayDesignStore.selectedWaterwayStations.some(reachID => 
          waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.some(p => 
            p.reachId === reachID && (p.depthEdited && !this.depthEdited)
          )
        );
        let resetWidth = waterwayDesignStore.selectedWaterwayStations.some(reachID => 
          waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.some(p => 
            p.reachId === reachID && (p.widthEdited && !this.widthEdited)
          )
        );
        if (resetDepth || resetWidth) {
          await MessageCenter.addNotificationFromCode('WDT_118', [
            {
              callback: () => {
                MessageCenter.clearMessages();
              },
              text: 'Cancel',
            },
            {
              callback: async () => {
                MessageCenter.clearMessages();
                await waterwayDesignStore.saveWaterwaySizingResponseDtoReaches(this.surfaceDesignVM?.addWDTEdits);
              },
              text: 'OK',
            },
          ], resetWidth ? 'Flow Top Width' : 'Flow Depth + FB');
        } else {
          await waterwayDesignStore.saveWaterwaySizingResponseDtoReaches(this.surfaceDesignVM?.addWDTEdits);
        }
      }
    } finally {
      this.isLoading = false;
    }
  }

  @action.bound handleReset() {
    this.resetSoilStrenth();
    this.resetChannelFlow();
    this.resetVegetalCover();
    this.resetResults();
    MessageCenter.resetMessageCenter();
  }

  @action.bound resetResults() {
    this.calculationResult = undefined;
    this.waterWayWizardStatus = 1;
    this.lastCalcPayload = undefined;
    this.lastOthersObj = undefined;
  }

  @action.bound resetChannelFlow() {
    if (this.channelFlowVM != undefined) {
      this.channelFlowVM.channelBedSlope = "RESET";
      this.channelFlowVM.designDischarge = "RESET";
      this.channelFlowVM.trapForm.bottomDip = "";
      this.channelFlowVM.trapForm.dipDepth = "RESET";
      this.channelFlowVM.trapForm.freeboard = "RESET";
      this.channelFlowVM.trapForm.leftSlope = "RESET";
      this.channelFlowVM.trapForm.minBedWidth = "RESET";
      this.channelFlowVM.trapForm.offset = [0.00, 0.00, 0.00];
      this.channelFlowVM.trapForm.rightSlope = "RESET";

      this.channelFlowVM.parabolicForm.freeboard = "RESET";
      this.channelFlowVM.parabolicForm.limitingSlope = "RESET";
      this.channelFlowVM.parabolicForm.offset = [50.00, 75.00, 100.00];

      this.channelFlowVM.channelOptions.fixFlowDepth = "RESET";
      this.channelFlowVM.channelOptions.fixFlowWidth = "RESET";
      this.channelFlowVM.formValidation.offset1 = false;
      this.channelFlowVM.formValidation.offset2 = false;
      this.channelFlowVM.formValidation.offset3 = false;
      this.channelFlowVM.formValidation.freeboard1 = false;
      this.channelFlowVM.formValidation.freeboard2 = false;
      this.channelFlowVM.formValidation.fixFlowDepth = false;
      this.channelFlowVM.formValidation.fixFlowWidth = false;
      this.channelFlowVM.formValidation.channelBedSlope = false;
      this.channelFlowVM.formValidation.designDischarge = false;
      this.channelFlowVM.formValidation.leftSlope = false;
      this.channelFlowVM.formValidation.rightSlope = false;
      this.channelFlowVM.formValidation.minBedWidth = false;
      this.channelFlowVM.formValidation.dipDepth = false;
      this.channelFlowVM.formValidation.limitingSlope = false;
      this.channelFlowVM.formValidation.channelFormErrors = false;

      this.channelFlowVM.formValidation.messages.channelBedSlope = "";
      this.channelFlowVM.formValidation.messages.designDischarge = "";
      this.channelFlowVM.formValidation.messages.dipDepth = "";
      this.channelFlowVM.formValidation.messages.fixFlowDepth = "";
      this.channelFlowVM.formValidation.messages.fixFlowWidth = "";
      this.channelFlowVM.formValidation.messages.freeboard1 = "";
      this.channelFlowVM.formValidation.messages.freeboard2 = "";
      this.channelFlowVM.formValidation.messages.leftSlope = "";
      this.channelFlowVM.formValidation.messages.limitingSlope = "";
      this.channelFlowVM.formValidation.messages.minBedWidth = "";
      this.channelFlowVM.formValidation.messages.offset1 = "";
      this.channelFlowVM.formValidation.messages.offset2 = "";
      this.channelFlowVM.formValidation.messages.offset3 = "";
      this.channelFlowVM.formValidation.messages.rightSlope = "";

      this.channelFlowVM.formClassName.channelBedSlope = "";
      this.channelFlowVM.formClassName.designDischarge = "";
      this.channelFlowVM.formClassName.dipDepth = "";
      this.channelFlowVM.formClassName.fixFlowDepth = "";
      this.channelFlowVM.formClassName.fixFlowWidth = "";
      this.channelFlowVM.formClassName.freeboard1 = "";
      this.channelFlowVM.formClassName.freeboard2 = "";
      this.channelFlowVM.formClassName.leftSlope = "";
      this.channelFlowVM.formClassName.limitingSlope = "";
      this.channelFlowVM.formClassName.minBedWidth = "";
      this.channelFlowVM.formClassName.offset1 = "";
      this.channelFlowVM.formClassName.offset2 = "";
      this.channelFlowVM.formClassName.offset3 = "";
      this.channelFlowVM.formClassName.rightSlope = "";
    }

  }

  @action.bound resetSoilStrenth() {
    if (this.soilStrengthVM != undefined) {

      this.soilStrengthVM.erodibilityForm.erodibility = "";

      this.soilStrengthVM.soilParameterForm.allowableStress = "";
      this.soilStrengthVM.soilParameterForm.d75 = "RESET";
      this.soilStrengthVM.soilParameterForm.plasticityIndex = "RESET";
      this.soilStrengthVM.soilParameterForm.soilGrainRoughness = "";
      this.soilStrengthVM.soilParameterForm.soilType = "";
      this.soilStrengthVM.soilParameterForm.voidRatio = "RESET";

      this.soilStrengthVM.soilStressForm.allowableStress = "RESET";
      this.soilStrengthVM.soilStressForm.soilGrainRoughness = 0.0156;

      this.soilStrengthVM.erodabilityClassName = '';
      this.soilStrengthVM.soilParameterFormClassName.soilType = '';
      this.soilStrengthVM.soilParameterFormClassName.d75 = "";
      this.soilStrengthVM.soilParameterFormClassName.plasticityIndex = "";
      this.soilStrengthVM.soilParameterFormClassName.voidRatio = "";
      this.soilStrengthVM.soilParameterFormClassName.allowableStress = "calculated-result-box";

      this.soilStrengthVM.soilStressFormClassName.allowableStress = "";
      this.soilStrengthVM.soilStressFormClassName.soilGrainRoughness = "";

      this.soilStrengthVM.formValidation.erodibilityForm.erodibility = false;
      this.soilStrengthVM.formValidation.soilParameterForm.allowableStress = true;
      this.soilStrengthVM.formValidation.soilParameterForm.d75 = false;
      this.soilStrengthVM.formValidation.soilParameterForm.d75InitialValueChange = false;
      this.soilStrengthVM.formValidation.soilParameterForm.plasticityIndex = false;
      this.soilStrengthVM.formValidation.soilParameterForm.plasticityIndexInitialValueChange = false;
      this.soilStrengthVM.formValidation.soilParameterForm.soilGrainRoughness = true;
      this.soilStrengthVM.formValidation.soilParameterForm.soilType = false;
      this.soilStrengthVM.formValidation.soilParameterForm.voidRatio = false;
      this.soilStrengthVM.formValidation.soilParameterForm.voidRatioInitialValueChange = false;

      this.soilStrengthVM.formValidation.soilStressForm.allowableStress = false;
      this.soilStrengthVM.formValidation.soilStressForm.allowableStressInitialValueChange = false;
      this.soilStrengthVM.formValidation.soilStressForm.soilGrainRoughness = true;
      this.soilStrengthVM.formValidation.soilStressForm.soilGrainRoughnessInitialValueChange = false;

      this.soilStrengthVM.formaValidationResult.validationResultErodibilityForm = false;
      this.soilStrengthVM.formaValidationResult.validationResultSoilParameterForm = false;
      this.soilStrengthVM.formaValidationResult.validationResultSoilStressForm = false;
    }
  }

  @action.bound resetVegetalCover() {
    if (this.vegetalCoverVM !== undefined) {
      this.vegetalCoverVM.defineVegetalCoverForm.vegetalCoverDropdown = "";
      this.vegetalCoverVM.defineVegetalCoverForm.manualboxOne = "";
      this.vegetalCoverVM.defineVegetalCoverForm.manualboxTwo = "RESET";
      this.vegetalCoverVM.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability = "";
      this.vegetalCoverVM.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity = "";
      this.vegetalCoverVM.defineVegetalCoverForm.rciForm.rciStability = "RESET";
      this.vegetalCoverVM.defineVegetalCoverForm.rciForm.rciCapacity = "RESET";
      this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityLength = "RESET";
      this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityDensity = "RESET";
      this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityLength = "RESET";
      this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityDensity = "RESET";
      this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemStabilityRci = 0;
      this.vegetalCoverVM.defineVegetalCoverForm.stemLengthDensityForm.stemCapacityRci = 0;
      this.vegetalCoverVM.defineVegetalCoverForm.manningForm.manningStability = "RESET";
      this.vegetalCoverVM.defineVegetalCoverForm.manningForm.manningCapacity = "RESET";

      this.vegetalCoverVM.formValidation.hasError = false;
      this.vegetalCoverVM.formValidation.vegetalCoverDropdown = false;
      this.vegetalCoverVM.formValidation.manualboxOne = false;
      this.vegetalCoverVM.formValidation.manualboxTwo = false;
      this.vegetalCoverVM.formValidation.retardanceClassForCapacity = false;
      this.vegetalCoverVM.formValidation.retardanceClassForStability = false;
      this.vegetalCoverVM.formValidation.rciCapacity = false;
      this.vegetalCoverVM.formValidation.rciStability = false;
      this.vegetalCoverVM.formValidation.stemLengthCapacityDensity = false;
      this.vegetalCoverVM.formValidation.stemLengthCapacityLength = false;
      this.vegetalCoverVM.formValidation.stemLengthStabilityDensity = false;
      this.vegetalCoverVM.formValidation.stemLengthStabilityLength = false;
      this.vegetalCoverVM.formValidation.stemStabilityRci = false;
      this.vegetalCoverVM.formValidation.stemCapacityRci = false;
      this.vegetalCoverVM.formValidation.manningCapacity = false;
      this.vegetalCoverVM.formValidation.manningStability = false;

      this.vegetalCoverVM.formValidation.formErrors.vegetalCoverDropdown = "";
      this.vegetalCoverVM.formValidation.formErrors.manualboxTwo = "";
      this.vegetalCoverVM.formValidation.formErrors.manualboxTwo = "";
      this.vegetalCoverVM.formValidation.formErrors.retardanceClassForm.retardanceClassForCapacity = "";
      this.vegetalCoverVM.formValidation.formErrors.retardanceClassForm.retardanceClassForStability = "";
      this.vegetalCoverVM.formValidation.formErrors.rciForm.rciCapacity = "";
      this.vegetalCoverVM.formValidation.formErrors.rciForm.rciStability = "";
      this.vegetalCoverVM.formValidation.formErrors.stemLengthDensityForm.stemLengthCapacityDensity = "";
      this.vegetalCoverVM.formValidation.formErrors.stemLengthDensityForm.stemLengthCapacityLength = "";
      this.vegetalCoverVM.formValidation.formErrors.stemLengthDensityForm.stemLengthStabilityDensity = "";
      this.vegetalCoverVM.formValidation.formErrors.stemLengthDensityForm.stemLengthStabilityLength = "";
      this.vegetalCoverVM.formValidation.formErrors.stemLengthDensityForm.stemCapacityRCI = "";
      this.vegetalCoverVM.formValidation.formErrors.stemLengthDensityForm.stemStabilityRCI = "";
      this.vegetalCoverVM.formValidation.formErrors.manningForm.manningCapacity = "";
      this.vegetalCoverVM.formValidation.formErrors.manningForm.manningStability = "";


    }

  }


}






